<script>
    import { a } from '../../../shared/globalState/a';
    import CloseIcon from '../tomat/icons/CloseIcon.svelte';
    import { linear } from 'svelte/easing';
    import { scale } from 'svelte/transition';
    import * as Mousetrap from 'mousetrap';
    import { BlockData } from '../../../models/BlockData';

    export let isVisible;
    export let title;
    export let message;

    let tic = 'h-5 w-5 text-slate-500';
    let inputCode;
    let inputDesc;
    let inputSize;
    let inputKms;
    let inputKvs;

    let transitionOptions = {
        duration: 100,
        easing: linear,
    };

    let data;

    a.storedAliases$.subscribe((aliases) => {
        data = aliases;
    });

    function bindKeys(node){

        // почему если фокус в поле ввода, привязка не срабатывает?
        // а вот почему:
        /**
         * By default all keyboard events will not fire if you are inside of a textarea, input, or select to prevent undesirable things from happening.
         * https://craig.is/killing/mice#api.reset
         */

        Mousetrap(node).bind('esc', ()=>{
            close();
        });
        Mousetrap(node).bind('enter', ()=>{
            
            let code = inputCode.value;
            let desc = inputDesc.value;
            let size = inputSize.value;
            let kms = inputKms.value;
            let kvs = inputKvs.value;

            
            let block = data?.find(x=>x.code === code);

            if(block){
                a.showAlertDialog$.next({
                    title: 'Информация',
                    message: `Блок с кодом "${v}" уже существует. Выберите другое имя`,
                    isVisible: true,
                })
            }
            else{
                a.addToBlockCollection$.next(new BlockData(code,desc,size,kms,kvs));
            }
            
        });
        
    }

    function close() {
        a.showInputBlockCollectionDialog$.next({ isVisible: false });
        Mousetrap.unbind('esc');
        Mousetrap.unbind('enter');
    }

    function focus(element){
        element.focus();
    }
</script>

{#if isVisible}
    <div class="dialog-container" transition:scale={transitionOptions} use:bindKeys>
        <div class="flex-row jce">
            <button on:click={close}>
                <CloseIcon {tic}></CloseIcon>
            </button>
        </div>
        <div class="title-container">
            <span>{title}</span>
        </div>
        <div class="message-container">
            <p>{message}</p>
            <div class="flex-column">
                <input class="input m-mb-05" placeholder="Код или название элемента ..." type="text" use:focus bind:this={inputCode}>
                <input class="input m-mb-05" placeholder="Описание ..." type="text" bind:this={inputDesc}>
                <input class="input m-mb-05" placeholder="Размер ..." type="text" bind:this={inputSize}>
                <input class="input m-mb-05" placeholder="КМС ..." type="text" bind:this={inputKms}>
                <input class="input m-mb-05" placeholder="Kvs ..." type="text" bind:this={inputKvs}>
            </div>
        </div>
    </div>
{/if}

<style>
    .dialog-container {
        position: absolute;
        z-index: 50;
        transform: translate(50%, calc(100vh - 500px));
        width: 40%;
        border: 1px solid slategray;
        border-radius: 5px;
        background-color: #f1f5f9;
        padding: 0.5em 0.5em 1em 1em;
    }
    .title-container {
        font-size: 2em;
    }
    .message-container {
        font-size: 18px;
        line-height: 1.5;
        color: #333;
    }
    .input{
        padding: 0 .5em;
    }

</style>
